<template>
  <div
    class="saving-state"
    :class="cssClasses"
  >
    <div class="icon">
      <div class="animation">
        <div />
        <div />
      </div>
    </div>
    <span class="label">
      <span>{{ label }}</span>
    </span>
  </div>
</template>

<style lang="stylus" scoped>
  // thanks to waleri :D
  .animation
    position: absolute
    top 10px

    div
      position: absolute
      width: 2px
      height: 2px
      border-radius: 2px
      transform: rotate(-45deg)
      border-right: 16px solid white
      border-left: 4px solid white
      animation: glow 3s infinite, fight-left 1s infinite

      &:nth-of-type(2)
        transform: rotate(-135deg)
        margin-left: 1px
        animation: glow 3s infinite reverse, fight-right 1s infinite

    @keyframes fight-left
      0%
        transform: rotate(-45deg)
      30%
        transform: rotate(-20deg)
        filter: blur(.5px)
      50%
        transform: rotate(-20deg) translateY(-5px)
      70%
        transform: rotate(-70deg)
        filter: blur(.2px)
      100%
        transform: rotate(-45deg)

    @keyframes fight-right
      0%
        transform: rotate(-135deg)
      30%
        transform: rotate(-110deg)
        filter: blur(.5px)
      60%
        transform: rotate(-120deg) translateY(5px)
      80%
        transform: rotate(-160deg)
        filter: blur(.2px)
      100%
        transform: rotate(-135deg)

    @keyframes glow
      0%
        border-color: orange
        box-shadow: 1px 0 5px -.3px orange
      25%
        border-color: green
        box-shadow: 1px 0 7px -.3px green
      50%
        border-color: blue
        box-shadow: 1px 0 10px -.3px blue
      75%
        border-color: red
        box-shadow: 1px 0 7px -.3px red
      100%
        border-color: orange
        box-shadow: 1px 0 5px -.3px orange

  .saving-state
    display flex
    background #fff
    padding 6px 16px
    border-radius 15px
    justify-content center
    align-items center
    transition 800ms 500ms cubic-bezier(0.175, 0.885, 0.320, 1.275) all
    margin-top -50px
    opacity 0

    .icon
      position relative
      width 21px
      height 21px
      transition ease-in-out all 300ms

    .label
      overflow hidden
      padding-left 10px
      opacity 1
      width 1px
      transition 300ms 1500ms ease-in-out all

    &.visible
      opacity 1
      margin-top 0

      .label
        width 44px

    &.saved
      .icon
        width 0
        overflow hidden

      transition-delay 2s
      margin-top -50px
      opacity 0

</style>

<script>
  export default {
    name: 'EmSavingState',

    props: {
      saving: {
        type: Boolean,
        required: true
      }
    },

    data () {
      return {
        saved: false,
        visible: false,
        viewTimer: null,
        viewTimerElapsed: 1
      }
    },

    computed: {
      label () {
        return this.saved ? 'Okay!' : 'Saving'
      },

      cssClasses () {
        return {
          visible: this.visible,
          saved: this.saved
        }
      },

      doesNotDistract () {
        return !this.viewTimer
      }
    },

    watch: {
      saving (newSavingValue) {
        this.handleState(newSavingValue)
      }
    },

    mounted () {
      this.handleState(this.saving)
    },

    beforeDestroy () {
      if (this.viewTimer) {
        window.clearTimeout(this.viewTimer)
      }
    },

    methods: {
      handleState (newSavingValue) {
        if (newSavingValue && this.doesNotDistract) {
          this.setViewTimer()

          this.visible = true
          this.saved = false
        } else {
          this.saved = true

          window.setTimeout(() => {
            this.visible = false
          }, 2500)
        }
      },

      setViewTimer () {
        this.viewTimer = window.setTimeout(() => {
          this.viewTimerElapsed++
          this.viewTimer = null
        }, this.viewTimerElapsed * 1000 * 60 * 2) // will be doubled every time the timer elapsed
      }
    }
  }
</script>
